// PayoutManagement.jsx — 정산 관리 진입점 (어셈블리)
//
// companyCode prop으로 회사별 데이터 분기.
// 프론트엔드 코드는 하나, DB는 company_code로 구분.
// 파인그룹/DOT/LNJ 공통 사용.

import React from 'react';
import { usePayoutManagement } from './payoutmanagement/usePayoutManagement';
import { PayoutManagementView } from './payoutmanagement/PayoutManagementView';

/**
 * @param {string} companyCode - 'PINE' | 'DOT' | 'LNJ' (기본 'PINE')
 */
export default function PayoutManagement({ companyCode = 'PINE' }) {
  const state = usePayoutManagement({ companyCode });

  return <PayoutManagementView {...state} />;
}
